import axios from 'axios' // 引入axios
import indexSystem from '@/configure/commons/index'
import { ElMessage } from 'element-plus'
import router from '@/configure/router'
import store from '@/configure/store'
import {base64toFile} from "@/util/tool.js";
const Base64 = require('js-base64').Base64

export const MsgMessage = function (code, msg) {
  switch (parseInt(code)) {
    case 0:
      if (msg !== '') {
        ElMessage.success(msg)
      }
      break
    case 1:
      ElMessage.error(msg)
      break
    case 50:
      ElMessage.error(msg)
      store.commit('deleteUserData')
      router.push('/indexAdminLogin')
      break
    case 51:
      ElMessage.error(msg)
      break
    case 52:
      ElMessage.error(msg)
      break
  }
}

/**
 * 不带token的接口
 * @param options
 * @returns {Promise<*>}
 */
export const requestNoToken = async function (options) {
  options.url = indexSystem.baseApiUrl + options.url
  options.method = 'post'
  options.headers = { 'Content-Type': 'application/json;charset=utf-8' }

  return new Promise((resolve,reject) => {
    axios(options).then(res => {
      //  这里主要根据后来返回的数据作判断，请根据实际情况
      if (res.data.code === 0) {
        MsgMessage(res.data.code, res.data.message)
        resolve(res.data)
      } else {
        MsgMessage(res.data.code, res.data.message)
      }
    }).catch(err =>{
      ElMessage.error("请求失败")
    })
  })
}

/**
 * 带token的接口
 * @param options
 * @returns {Promise<undefined|*|Promise<any>>}
 */
export const requestToken = async function (options) {
  const adminToken = store.state.userData.adminToken
  if (adminToken === '' || adminToken === undefined) {
    router.push('/')
    return
  }

  options.url = indexSystem.baseApiUrl + options.url
  options.method = 'post'
  options.headers = { 'Content-Type': 'application/json;charset=utf-8', 'adminToken': adminToken }

  return new Promise((resolve,reject) => {
    axios(options).then(res => {
      //  这里主要根据后来返回的数据作判断，请根据实际情况
      if (res.data.code === 0) {
        MsgMessage(res.data.code, res.data.message)
        resolve(res.data)
      } else {
        MsgMessage(res.data.code, res.data.message)
      }
    }).catch(err =>{
      ElMessage.error("请求失败")
    })
  })
}

/**
 * 导出url
 * @param options
 * @returns {Promise<undefined|*|Promise<any>>}
 */
export const exportTokenUrl = async function (options) {
  const token = store.state.userData.token
  if (token === '' || token === undefined) {
    router.push('/')
    return
  }
  const dataStr = Base64.encode(JSON.stringify(options.data))
  window.open(indexSystem.baseApiUrl + options.url + '?dataStr=' + dataStr + '&adminToken=' + token)
}

/**
 * 根据base64上传文件
 * @param options
 * @returns {Promise<void>}
 */
export const uploadFileByBase64 = async function (options) {
  let axios = require('axios');
  let FormData = require('form-data');
  let data = new FormData();
  data.append('file', base64toFile(options));

  let config = {
    method: 'post',
    url: indexSystem.baseUploadApiUrl,
    data : data
  };
  return new Promise((resolve,reject) => {
    axios(config).then(res => {
      //  这里主要根据后来返回的数据作判断，请根据实际情况
      if (res.data.code === 0) {
        MsgMessage(res.data.code, res.data.message)
        resolve(res.data)
      } else {
        MsgMessage(res.data.code, res.data.message)
      }
    }).catch(err =>{
      ElMessage.error("请求失败")
    })
  })
}
